const consumerCache = {};

export const addConsumer = (key, host) => {
	if (!consumerCache[key]) {
		consumerCache[key] = new Set();
		return consumerCache[key].add(host);
	} else if (consumerCache[key].has(host)) {
		return;
	}

	consumerCache[key].add(host);
};

export const removeConsumer = host => {
	Reflect.ownKeys(consumerCache).forEach(k => {
		if (consumerCache[k].has(host)) {
			consumerCache[k].delete(host);
		}
	});
};

export const getConsumers = key => {
	return (consumerCache[key] && consumerCache[key].values()) || new Set().values();
};

export const removeConsumersForContextKey = key => {
	if (consumerCache[key]) consumerCache[key].clear();
};

export const removeAllConsumers = () => {
	Reflect.ownKeys(consumerCache).forEach(k => {
		delete consumerCache[k];
	});
};
